export default "__VITE_ASSET__qS7r622S__"